import { render } from "./HeaderCheckbox.vue?vue&type=template&id=53a2c9b8"
import script from "./HeaderCheckbox.vue?vue&type=script&lang=js"
export * from "./HeaderCheckbox.vue?vue&type=script&lang=js"
script.render = render

export default script